// extracted by mini-css-extract-plugin
export default {"select":"tna5EnmRu4Vvfa1YT4mB"};